module.exports = __webpack_public_path__ + "img/banner_usdt.9a71f7c9.png";